<template>
  <wrap-container>
    <help-title
      title="Programa de beneficios GO"
      descripcion="GO es la plataforma digital de beneficios que BBVA tiene para clientes y no clientes. Estos beneficios incluyen descuentos,
      sorteos, tarjetas regalo, tickets para shows en vivo, acceso a
      experiencias únicas en fútbol, espectáculos y mucho más."
    />

    <help-list-container>
      <help-list-item tituloLista="Descargá la app:">
        Para poder conocer todos los beneficios y recibir notificaciones, bajá
        la aplicación en tu celular y registrate.
      </help-list-item>

      <help-list-item tituloLista="Más información:">
        Ingresá al sitio de GO y enterate de todos los beneficios.
        <custom-link
          label="Ir a GO"
          href="https://www.bbva.com.ar/personas/servicios-digitales/bbva-go.html"
        />
      </help-list-item>

      <help-list-item tituloLista="¿No resolvimos tu consulta?">
        Podés dejar tus datos y un representante se podrá en contacto a la
        brevedad.
        <contact-link />
      </help-list-item>
    </help-list-container>
  </wrap-container>
</template>

<script>
import WrapContainer from "@/components/core/Container";
import HelpTitle from "@/components/core/HelpTitle";
import HelpListItem from "@/components/core/HelpListItem";
import HelpListContainer from "@/components/core/HelpListContainer";
import CustomLink from "@/components/core/CustomLink";
import ContactLink from "@/components/core/ContactLink";

export default {
  components: {
    WrapContainer,
    HelpTitle,
    HelpListItem,
    HelpListContainer,
    CustomLink,
    ContactLink
  }
};
</script>
